/* eslint-disable @next/next/no-html-link-for-pages */
import React, { useState, useEffect, useCallback } from "react";
import { GetCookie } from "../../provider/common";
import { authLogoutEnglish } from "../../provider/auth";

export default function NavEnglish() {
  const axios = require("axios").default;
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    isLoginCheck();
  }, []);

  async function isLoginCheck() {
    const isLogin = await GetCookie("isLogin");
    setIsLogin(Number(isLogin));
  }

  const _handleLogout = async () => {
    await authLogoutEnglish();
  };
  return (
    <div className="header_en_nav">
      <div className="header_en_nav_menu">
        <div>
          <a
            href={
              isLogin === 1
                ? "/en/estimate/request"
                : "/en/auth/login?before=/en/estimate/request"
            }
          >
            <i className="xi-pen-o"></i>
            <p>Create RFQ</p>
          </a>
        </div>
        <div>
          <a
            href={
              isLogin === 1
                ? "/en/estimate/lists"
                : "/en/auth/login?before=/en/estimate/lists"
            }
          >
            <i className="xi-paper"></i>
            <p>My RFQ</p>
          </a>
        </div>
        <div>
          <a
            href={
              isLogin === 1
                ? "/en/market/cart"
                : "/en/auth/login?before=/en/market/cart"
            }
          >
            <i className="xi-basket"></i>
            <p>RFQ Cart</p>
          </a>
        </div>
        {isLogin === 1 ? (
          <div>
            <a href="/en/mypage/home?path=My%20Account">
              <i className="xi-user"></i>
              <p>My Account</p>
            </a>
          </div>
        ) : isLogin === 0 ? (
          <div>
            <a href="/en/auth/login">
              <i className="xi-log-in"></i>
              <p>Sign In</p>
            </a>
          </div>
        ) : (
          ""
        )}

        {isLogin === 1 ? (
          <div>
            <button onClick={() => _handleLogout()}>
              <i className="xi-log-out"></i>
              <p>Sign Out</p>
            </button>
          </div>
        ) : isLogin === 0 ? (
          <div>
            <a href="/en/auth/register">
              <i className="xi-user-plus"></i>
              <p>Sign Up</p>
            </a>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
